// Embeds the Swagger API documentation inside the admin layout (Chakra shell).
import React from "react";
import { Flex, Text, useColorModeValue } from "@chakra-ui/react";
import Card from "horizon/components/card/Card";
import { config } from "config/environment";

const IFRAME_STYLE = { width: "100%", height: "100%", border: "none", display: "block", borderRadius: "16px" };

/**
 * Computes the API docs URL from the configured API base URL origin.
 * @returns {string} The /apidocs URL or empty string when apiUrl is invalid
 */
function getDocsUrl() {
  try { return config.apiUrl ? `${new URL(config.apiUrl).origin}/apidocs` : ""; }
  catch { return ""; }
}

/**
 * Renders the Swagger docs iframe, or an empty state when the URL is missing.
 * The browser handles HTTP Basic Auth via its native popup on first load.
 * @returns {React.ReactElement}
 */
function ApiDocs() {
  const docsUrl = getDocsUrl();
  const emptyColor = useColorModeValue("secondaryGray.600", "secondaryGray.400");
  return (
    <Card p="0" h="calc(100vh - 160px)" overflow="hidden">
      {docsUrl ? (
        <iframe src={docsUrl} title="Documentation API" style={IFRAME_STYLE} />
      ) : (
        <Flex align="center" justify="center" h="100%">
          <Text color={emptyColor}>URL de l'API non configurée.</Text>
        </Flex>
      )}
    </Card>
  );
}

export default ApiDocs;
